import script from "./addEntityBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./addEntityBtn.vue?vue&type=script&setup=true&lang=ts"

import "./addEntityBtn.vue?vue&type=style&index=0&id=430702d8&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-430702d8"]])

export default __exports__